import { SampleTrackerData, StudyInfo } from '../../../sample-tracking/group-info/study-group-info';
import { BaseBuildPart } from './../base-build-part';
import { HelperParams } from './../helper-params';

export class ProtocolDashboardBuildPart extends BaseBuildPart {
    constructor(
        private readonly protocolHelperParams: HelperParams,
        parent: BaseBuildPart,
        protocolInfo: SampleTrackerData) {
        super(protocolHelperParams, parent, ['samples', protocolInfo.protocolFk, 'protocol']);
    }

    public protocolDashboard(): BaseBuildPart {
        return new BaseBuildPart(this.protocolHelperParams, this, ['protocol']);
    }

    public filterSamples(type: string): BaseBuildPart {
        return new BaseBuildPart(this.protocolHelperParams, this, ['filter-samples', type]);
    }
}
